class SimpleNavigationObserver extends HTMLElement {
  connectedCallback() {
    if (this._init) return; 
    this._init = true;

    this._navSel    = this.getAttribute('data-nav')     || '.navigation-list-item';
    this._anchorSel = this.getAttribute('data-anchors') || '[data-anchor]';
    this._offset    = parseInt(this.getAttribute('data-offset') || '0', 10);
    this._eps       = 1;

    this._activeIndex = -1;
    this._lockScroll  = false;
    this._grab();

    // Eventhandler
    this._onScroll = () => {
      if (this._lockScroll) return;
      this._applyActive();
    };
    this._onResize = () => {
      this._cacheAnchorPositions();
      if (!this._lockScroll) this._applyActive();
    };
    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onResize);
    window.addEventListener('load',   this._onResize);
    window.addEventListener('scrollend', () => {
      if (this._lockScroll) {
        this._lockScroll = false;
      }
    });

    this._mo = new MutationObserver(() => {
      this._grab();
      this._cacheAnchorPositions();
      if (!this._lockScroll) this._applyActive();
    });
    this._mo.observe(this, { childList: true, subtree: true });

    this.addEventListener('click', e => {
      const link = e.target?.closest('a');
      if (!link) return;
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      const id = href.slice(1);
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();

      const idx = this._findIndexByAnchorId(id);
      if (idx > -1) {
        this._setActive(idx);
        this._activeIndex = idx;
      }
      const rect = target.getBoundingClientRect();
      const absoluteTop = window.pageYOffset + rect.top;
      const targetY = Math.max(absoluteTop - this._offset, 0);
      this._lockScroll = true; // Scrollspy sperren
      window.scrollTo({ top: targetY, behavior: 'smooth' });
      history.pushState(null, '', '#' + id);
    });

    this._cacheAnchorPositions();
    this._applyActive();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onResize);
    window.removeEventListener('load',   this._onResize);
    if (this._mo) this._mo.disconnect();
  }

  _grab() {
    const anchors = Array.from(this.querySelectorAll(this._anchorSel));
    const items   = Array.from(this.querySelectorAll(this._navSel));
    const filteredAnchors = anchors.filter(anchor => {
      const anchorId = anchor.id;
      return items.some(item => {
        const a = item.querySelector('a');
        return a && a.getAttribute('href') === '#' + anchorId;
      });
    });
    const filteredItems = items.filter(item => {
      const a = item.querySelector('a');
      if (!a) return false;
      const href = a.getAttribute('href');
      if (!href || !href.startsWith('#')) return false;
      const id = href.slice(1);
      return filteredAnchors.some(anchor => anchor.id === id);
    });
    const n = Math.min(filteredAnchors.length, filteredItems.length);
    this._anchors = filteredAnchors.slice(0, n);
    this._navLinks = filteredItems.slice(0, n);
  }
  _cacheAnchorPositions() {
    this._anchorPositions = this._anchors?.map(a => {
      const rect = a.getBoundingClientRect();
      return window.pageYOffset + rect.top;
    }) || [];
  }
  _applyActive() {
    if (!this._anchors?.length) return;
    let activeIndex = 0;
    const off = this._offset, eps = this._eps;
    const scrollY = window.pageYOffset;
    for (let i = 0; i < this._anchorPositions.length; i++) {
      if (this._anchorPositions[i] - off <= scrollY + eps - off) {
        activeIndex = i;
      } else break;
    }
    if (activeIndex !== this._activeIndex) {
      this._setActive(activeIndex);
      this._activeIndex = activeIndex;
    }
  }
  _setActive(index) {
    this._navLinks.forEach((li, i) => {
      const on = i === index;
      li.classList.toggle('is-active', on);
      const a = li.querySelector('a');
      if (a) on ? a.setAttribute('aria-current', 'true') : a.removeAttribute('aria-current');
    });
  }
  _findIndexByAnchorId(id) {
    for (let i = 0; i < this._anchors.length; i++) {
      if (this._anchors[i].id === id) return i;
    }
    return -1;
  }
}
if (!customElements.get("navigation-observer")) {
  customElements.define('navigation-observer', SimpleNavigationObserver);
}
function emulateScrollEnd(){
  if ("onscrollend" in window || window.scrollEnd == true) {
    // Browser unterstützt scrollend nativ → nichts tun
    return;
  }
  window.scrollEnd = true;
  let scrollTimeout;
  window.addEventListener("scroll", () => {
    console.log("SCROLL")
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      window.dispatchEvent(new Event("scrollend"));
    }, 50); // 50ms ohne Scroll = Ende
  }, { passive: true });
}

if(!("onscrollend" in window)){
  emulateScrollEnd();
}